import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { entryPaths } from '@/mocks/entryPaths';

export default function QuickEntrySection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <SectionHeading
          eyebrow="Quick Access"
          title="六大常用入口，一步到位"
          desc="从首页入口到移动端访问，把最常走的几条路径集中呈现。点击卡片即可进入对应内容区。"
        />
        <Link
          to="/guide"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap shrink-0"
        >
          查看完整访问指南
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {entryPaths.map((item, index) => (
          <Reveal key={item.id} delay={index * 50}>
            <article className="h-full bg-background-100 border border-background-200 rounded-lg p-6 hover:border-primary-300 transition-colors group">
              <div className="flex items-start justify-between gap-4">
                <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center text-2xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={item.icon} />
                </span>
                <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs whitespace-nowrap">
                  {item.badge}
                </span>
              </div>
              <h3 className="font-heading mt-5 text-lg font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <p className="mt-4 flex items-start gap-2 text-xs text-accent-700">
                <i className="ri-lightbulb-line mt-0.5" />
                {item.tips}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}